export const initRippleData = {
    active: false,
    restart: false,
    hideRipple: false,
    diameter: 0,
    x: 0,
    y: 0
}

export type RippleData = typeof initRippleData;